/**
 * Targets the server side hub will send to client side hub
 */
export const NEW_COMMUNICATION_TARGET = 'newCommunication';
